module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ../~/rc-switch/es/index.js
// module id = 2016
// module chunks = 1